<form (ngSubmit)="login($event)">
  <div class="col-12 signin-xlarge" i18n="Sign In | Sign In header">Sign In</div>
  <div class="textinput accelaControl col-12" (click)="adminSelection($event,'username')">
    <input name="username" id="username" type="text" pInputText inputTrim [(ngModel)]="username" aria-required="true" [disabled]="false" 
      [placeholder]="userNamePlaceHolder" [accelaTooltip]="userNameControlDto.tooltip" tooltipPosition="bottom" tooltipEvent="hover|focus" [escape]="false">
    <label for="username" data-required="true">{{userNameControlDto.label}}</label>
  </div>
  <div class="textinput accelaControl col-12" (click)="adminSelection($event, 'passwordRequired')">
    <input name="password" id="passwordRequired" type="password" pPassword [(ngModel)]="password" aria-required="true" [disabled]="false" [feedback]="false"
      [placeholder]="passwordPlaceHolder" [accelaTooltip]="passwordControlDto.tooltip" tooltipPosition="bottom" tooltipEvent="hover|focus" [escape]="false">
    <label for="passwordRequired" data-required="true">{{passwordControlDto.label}}</label>
  </div>
  <p-dialog modal="true" closable="true" showHeader="false" [(visible)]="displayAdminOverlay" #adminOverlay>
    <div class="propertyInput p-formgroup-inline">
      <div class="p-field">
        <label i18n="Default Label | Default Label Display">Default Label</label>
        <input #DefaultLabelContent name="DefaultLabelContent" id="DefaultLabelContent" type="text" pInputText [disabled]="true" [value]="selectedDto.defaultLabel">
      </div>
    </div>
    <div class="propertyInput p-formgroup-inline">
      <div class="p-field">
        <label i18n="Label Content | Label Editor Label" for="FieldLabelContent" for="FieldLabelContent">Label Content</label>
        <input #FieldLabelContent name="FieldLabelContent" id="FieldLabelContent" type="text" pInputText [(ngModel)]="selectedDto.label" autofocus>
      </div>
    </div>
    <div class="propertyInput p-formgroup-inline">
      <div *ngIf="selectedDto.name !== 'rememberMeControl'" class="p-field">
        <label i18n="Tooltip Content | Tooltip Editor Label" for="FieldTooltip">Tooltip Content</label>
        <p-editor #FieldTooltip name="FieldTooltip" id="FieldTooltip" placeholder="Tooltip Content" [(ngModel)]="selectedDto.tooltip"></p-editor>
      </div>
    </div>
    <div class="propertyInput p-formgroup-inline">
      <div *ngIf="selectedDto.name !== 'rememberMeControl'" class="p-field">
        <label i18n="Watermark Content | Watermark Editor Label" for="FieldWatermark">Watermark Content</label>
        <input #FieldWatermark name="FieldWatermark" id="FieldWatermark" type="text" pInputText [(ngModel)]="selectedDto.placeholder">
      </div>
    </div>
    <div>
      <accela-button-primary type="button" (onClicked)="submitAdminContentUpdate(selectedDto)" i18n-label label="Submit" pRipple></accela-button-primary>
    </div>
  </p-dialog>
  <div class="col-12" >
    <a i18n="Forgot Password? | Forgot password link" class="col-12 forgotPassLink pl-1 pointCursor" (click)="forgotPassword($event)" (keydown.enter)="forgotPassword($event)" tabindex="0">Forgot Password?</a>
  </div>
  <div id="captcha" class="col-12 captcha" *ngIf="recaptchaLoaded && RecaptchaInfo?.IsCaptchaEnabledForLogin">
    <aca-recaptcha [RecaptchaPublicKey]="RecaptchaInfo?.RecaptchaPublicKey" (verifyUser)="updateRecaptchaStatus($event)"></aca-recaptcha>
  </div>
  <div class="col-12">
    <accela-button-primary pRipple [disabled]="!recaptchaLoaded || adminMode" i18n-label i18n="Sign In | LogIn Button" label="Sign In"></accela-button-primary>
    <input type="submit" value="submit" style="visibility: hidden" />
  </div>
  <div class="col-12">
    <p-checkbox [disabled]="adminMode" [ariaLabel]="rememeberMeDto.label" name="cbRememerMe" id="cbRememerMe" [binary]="true" label="" [(ngModel)]="rememberMe" pRipple></p-checkbox>
    <label class="pl-2" i18n="Remember me on this device | Remember me" for="cbRememerMe">Remember me on this device</label>
  </div>
    <accela-separator style="background-color: #e4dddd;"></accela-separator>
</form>
    <p-footer>
      <div *ngIf="licenseRequiredForRegistration;then licenseReqContent else nonLlicenseContent"></div>
      <ng-template #licenseReqContent>
        <div class="text-center" i18n="Are you a licensed professional? | Licensed professional">Are you a licensed professional?</div>
      </ng-template>
      <ng-template #nonLlicenseContent>
        <div class="text-center" i18n="Not Registered? | Register">Not Registered?</div>
      </ng-template>
      <p *ngIf="showRegistrationLinks" class="text-center "><a class="pointCursor"><span (keydown.enter)="newUserRegistration($event)" (click)="newUserRegistration($event)" tabindex="0" class="text-upper footerText" i18n="Create an Account | Create an Account"> Create an Account</span></a></p>
    </p-footer>

